import { getImageFromDB, saveImageToDB } from "./indexedDB";

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`image failed to load: ${src.slice(0, 80)}`));
    img.src = src;
  });

// Composites the saved label onto a product mockup and stores it in 'onProductImages'
// under `${product.id}_${resultImageId}` — the key every cart/thank-you component reads.
// Geometry (36% width, y/1.65) matches the legacy composites in CheckoutSimplified and
// ProductSelect exactly. Returns true when the composite was stored, false when the
// label blob is missing (no object URL is created — callers read from IndexedDB).
export async function compositeLabelOnProduct(product, resultImageId) {
  const labelBlob = await getImageFromDB("resultImages", resultImageId);
  if (!labelBlob) return false;

  const labelUrl = URL.createObjectURL(labelBlob);
  try {
    let mockup = null;
    try {
      mockup = await loadImage(product.image);
    } catch (err) {
      // Signed catalog CDN URLs may refuse cross-origin canvas loads (CORS). The
      // composite is best-effort display sugar — fall back to the label itself as the
      // cart image rather than leaving the line imageless.
      console.warn("mockup not canvas-loadable, storing label as cart image:", err.message);
      await saveImageToDB("onProductImages", `${product.id}_${resultImageId}`, labelBlob, product.id, resultImageId);
      return true;
    }
    const label = await loadImage(labelUrl);
    const canvas = document.createElement("canvas");
    canvas.width = mockup.width;
    canvas.height = mockup.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(mockup, 0, 0, canvas.width, canvas.height);

    const overlayWidth = canvas.width * 0.36;
    const overlayHeight = (overlayWidth * label.height) / label.width;
    const overlayX = (canvas.width - overlayWidth) / 2;
    const overlayY = (canvas.height - overlayHeight) / 1.65;
    ctx.drawImage(label, overlayX, overlayY, overlayWidth, overlayHeight);

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
    if (!blob) return false;
    await saveImageToDB("onProductImages", `${product.id}_${resultImageId}`, blob, product.id, resultImageId);
    return true;
  } finally {
    URL.revokeObjectURL(labelUrl);
  }
}
